import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref } from "vue";
import { getVentasPorPeriodoAction } from "../actions";

export function useVentasPeriodoQuery(
  fechaInicio: Ref<string>,
  fechaFin: Ref<string>,
  enabled: Ref<boolean>
) {
  return useQuery({
    queryKey: computed(() => [
      "ventas-periodo",
      fechaInicio.value,
      fechaFin.value,
    ]),
    queryFn: async () => {
      const response = await getVentasPorPeriodoAction(
        fechaInicio.value,
        fechaFin.value
      );
      return response.data;
    },
    enabled: () => enabled.value && !!fechaInicio.value && !!fechaFin.value,
    staleTime: 60000, // Los datos son frescos por 1 minuto
    placeholderData: (previousData) => previousData,
  });
}
